// Version token appended to product image URLs to bust caches
const IMG_VER: string = (process.env.NEXT_PUBLIC_IMG_VERSION || process.env.NEXT_PUBLIC_ASSET_VERSION || '') as string

const withImgVer = (url?: string | null) => {
  if (!url) return url
  if (!url.startsWith('/assets/products/')) return url
  return IMG_VER ? `${url}?v=${IMG_VER}` : url
}

export function hydrateProduct(product: any) {
  const toNum = (v: any) => (v == null ? null : (typeof v === 'number' ? v : (isFinite(Number(v)) ? Number(v) : null)))
  const salePrice = toNum(product.pricing?.salePrice)
  const listPrice = toNum(product.pricing?.listPrice)
  const price = (salePrice ?? listPrice ?? null)

  const baseGallery = product.media?.gallery?.length ? product.media.gallery : []
  const variantOptionsRaw = product.variants?.options ?? []

  const variantOptions = variantOptionsRaw.map((option: any) => {
    const optionSalePrice = toNum(option?.salePrice)
    const optionListPrice = toNum(option?.listPrice)
    const skuImage = option.sku ? withImgVer(`/assets/products/${option.sku}/1.webp`) : null
    const fallbackRaw = option.image ?? skuImage ?? product.media?.heroImage ?? baseGallery[0] ?? null
    const fallbackImage = withImgVer(fallbackRaw)
    let gallery: string[]
    if (option.gallery?.length) {
      gallery = option.gallery.map(withImgVer)
    } else {
      // Fallback: ensure the variant cover shows first, then append product gallery (deduped)
      const base = baseGallery.map(withImgVer)
      const arr = fallbackImage ? [fallbackImage, ...base] : base
      // Deduplicate while preserving order
      const seen = new Set<string>()
      gallery = arr.filter((u) => { if (!u) return false; if (seen.has(u)) return false; seen.add(u); return true })
    }
    return {
      ...option,
      image: fallbackImage,
      gallery,
      salePrice: optionSalePrice ?? salePrice,
      listPrice: optionListPrice ?? listPrice,
      price: optionSalePrice ?? optionListPrice ?? salePrice ?? listPrice ?? null,
    }
  })

  const defaultVariant = variantOptions.find((o: any) => o.isDefault) ?? variantOptions[0] ?? null
  const cover = defaultVariant?.image ?? withImgVer(product.media?.heroImage) ?? withImgVer(baseGallery[0]) ?? null
  const images = defaultVariant?.gallery?.length
    ? defaultVariant.gallery
    : baseGallery.length
      ? baseGallery.map(withImgVer)
      : cover
        ? [cover]
        : []

  const rating = product.ratings?.average ?? null
  const reviewsCount = product.ratings?.count ?? null
  const material = product.specifications?.material ?? null
  const thickness = product.specifications?.thickness ?? null
  const amazonUrl = (product as any)?.amazonUrl ?? product.amazon?.url ?? null

  const variants = product.variants
    ? {
        type: product.variants.type ?? 'variant',
        label: product.variants.label ?? 'Options',
        options: variantOptions,
        defaultId: defaultVariant?.id ?? null,
      }
    : null

  return {
    ...product,
    price,
    listPrice,
    salePrice,
    cover,
    images,
    rating,
    reviewsCount,
    material,
    thickness,
    amazonUrl,
    keywords: product.keywords ?? [],
    variants,
  }
}
